module.exports = __webpack_public_path__ + "static/media/cate1.23ef2e81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cate1.jpg
// module id = 230
// module chunks = 0